import React, { useMemo } from "react";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";
import { Badge } from "@shared/ui/badge";
import { Card, CardContent } from "@shared/ui/card";
import { SubtypeDetail, CustomField } from "../Detail";

interface CustomFieldsTabProps {
  detail: SubtypeDetail;
}

export default function CustomFieldsTab({ detail }: CustomFieldsTabProps) {
  const columns: TableColumn<CustomField>[] = useMemo(
    () => [
      {
        key: "id",
        header: "#",
        type: "custom",
        render: (value, row, index) => <span className="text-gray-400">{(index ?? 0) + 1}</span>,
      },
      {
        key: "label",
        header: "Field label",
        type: "custom",
        render: (value) => <span className="font-semibold text-gray-900">{value}</span>,
      },
      {
        key: "type",
        header: "Type",
        type: "custom",
        render: (value) => (
          <Badge variant="outline" className="text-gray-600 bg-gray-50 border-gray-200">
            {value}
          </Badge>
        ),
      },
      {
        key: "required",
        header: "Required",
        type: "custom",
        render: (value) => (
          value ? (
            <Badge variant="outline" className="text-red-600 bg-red-50 border-red-200 font-semibold">
              Required
            </Badge>
          ) : (
            <Badge variant="outline" className="text-gray-500 bg-gray-50 border-gray-200 font-semibold">
              Optional
            </Badge>
          )
        ),
      },
      {
        key: "placeholder",
        header: "Placeholder / options",
        type: "custom",
        render: (value) => <span className="text-gray-500 font-medium">{value || "—"}</span>,
      },
    ],
    []
  );

  return (
    <Card className="border-gray-200 shadow-sm">
      <CardContent className="p-6 space-y-4">
        <p className="text-sm text-gray-500">
          These fields are collected when <strong className="text-gray-700">{detail.name}</strong> is selected on a resource record.
        </p>
        <GenericTable
          data={detail.customFields}
          columns={columns}
          rowKey="id"
          emptyMessage="No custom fields configured"
        />
      </CardContent>
    </Card>
  );
}
